import React from "react";
import Fade from "react-reveal/Fade";

class Meet extends React.Component {
  render() {
    return (
      <div className="meetContentWrapper">
        <div className="meetHeader">
          <h1 className="styledHeader">Meet</h1>
          <h1 className="heading2">
            Our Top <span className="highlight">Employees</span>
          </h1>
        </div>

        <div className="employeeContentWrapper">
          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person1.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="staffIdentity">
                <h4>Emmaccen E.</h4>
                <h4 className="heading2">CEO Echo</h4>
              </div>
            </Fade>
          </div>

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person2.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="staffIdentity">
                <h4>Precious A.</h4>
                <h4 className="heading2">CEO Post-It</h4>
              </div>
            </Fade>
          </div>

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person3.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="staffIdentity">
                <h4>Bianka N.</h4>
                <h4 className="heading2">Founder Roboto</h4>
              </div>
            </Fade>
          </div>

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person4.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="staffIdentity">
                <h4>David A.</h4>
                <h4 className="heading2">Founder Irislens</h4>
              </div>
            </Fade>
          </div>

          {/* =================================================================== */}

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person5.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="staffIdentity">
                <h4>John S.</h4>
                <h4 className="heading2">Branch Manager</h4>
              </div>
            </Fade>
          </div>

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person6.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="staffIdentity">
                <h4>Larry P.</h4>
                <h4 className="heading2">Co-Investor Page</h4>
              </div>
            </Fade>
          </div>

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person7.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="staffIdentity">
                <h4>Daniel U.</h4>
                <h4 className="heading2">Social Influencer</h4>
              </div>
            </Fade>
          </div>

          <div className="employeeContainer">
            <Fade bottom>
              <div
                style={{ backgroundImage: `url(${"staffImages/person8.jpg"})` }}
                className="backgroundFix staffImage"
              >
                <div className="staffLinks">
                  <ul>
                    <li>
                      <a
                        className="icon icon-instagram2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-facebook2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-linkedin2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="icon icon-twitter2"
                        href="https://emmaccen.netlify.app/"
                      >
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="staffIdentity">
                <h4>Wong P.</h4>
                <h4 className="heading2">Founder Smartly</h4>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    );
  }
}

export default Meet;
